jQuery(document).ready(function($) {
	$('.js-tabs').each(function() {
		var self = { componentEl: $(this), navbar: {}, cssClass: {}, resizeTimer: false };
		self.class = 'js-tabs';
		self.itemEls = self.componentEl.find('.' + self.class + '__item');
		self.navbar.calculable = false;
		self.navbar.activeIndex = 0;
		self.navbar.itemData = [];
		self.navbar.baseEl = self.componentEl.find('.' + self.class + '__navbar');
		self.navbar.itemsEl = self.componentEl.find('.' + self.class + '__navbar-items');
		self.navbar.itemEls = self.componentEl.find('.' + self.class + '__navbar-item');
		self.parameters = {
			navbarItemActiveClass: '',
			navbarItemInactiveClass: '',
		};
		jQuery.extend(self.parameters, self.componentEl.data('tabsParameters'));

		self.selectNavbarItem = function(index) {
			self.navbar.itemEls.addClass(self.parameters.navbarItemInactiveClass);
			self.navbar.itemEls.removeClass(self.parameters.navbarItemActiveClass);
			$(self.navbar.itemEls.get(index)).removeClass(self.parameters.navbarItemInactiveClass);
			$(self.navbar.itemEls.get(index)).addClass(self.parameters.navbarItemActiveClass);
		};

		self.showItemByIndex = function(index) {
			self.itemEls.addClass('hidden');
			$(self.itemEls.get(index)).removeClass('hidden');
		};

		self.updateNavbarControls = function() {
			var itemSumWidth = 0;
			var baseWidth = self.navbar.baseEl.width();

			self.navbar.itemEls.each(function(index) {
				var item = {
					width: $(this).outerWidth(false),
					offset: itemSumWidth,
					center: itemSumWidth - ((baseWidth - $(this).outerWidth(false)) / 2),
					index: index
				};

				if (item.center < 0) {
					item.center = 0;
				}

				itemSumWidth += $(this).outerWidth(true);
				self.navbar.itemData[index] = item;
			});

			$.each(self.navbar.itemData.slice().reverse(), function(index, item) {
				if ((item.offset + item.width + (item.offset - item.center)) <= itemSumWidth) {
					return false;
				}

				item.center = itemSumWidth - baseWidth;
			});

			self.navbar.calculable = itemSumWidth > baseWidth;

			if (self.navbar.calculable) {
				self.moveNavberOffset();
			} else {
				self.navbar.itemsEl.css('left', 0);
			}
		};

		self.moveNavberOffset = function() {
			self.navbar.itemsEl.css(
				'left',
				self.navbar.itemData[self.navbar.activeIndex].center * -1
			);
		};

		self.navbar.itemEls.each(function(index, item) {
			var itemEl = $(item);

			if (itemEl.hasClass(self.parameters.navbarItemActiveClass)) {
				self.navbar.activeIndex = index;
			}

			itemEl.on('click', function(event) {
				if (!itemEl.hasClass(self.class + '__navbar-item--link')) {
					event.preventDefault();

					self.selectNavbarItem(index);
					self.showItemByIndex(index);
					self.navbar.activeIndex = index;
					if (self.navbar.calculable) {
						self.moveNavberOffset();
					}
				}
			});
		});

		$(window).on('resize', function() {
			clearTimeout(self.resizeTimer);
			self.resizeTimer = setTimeout(function() {
				self.updateNavbarControls();
			}, 250);
		});

		self.updateNavbarControls();
	});
});
